"use client";
import { Image } from '@/lib/target';
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "@/context/ThemeContext";
import HideShow from "@/assets/images/hide_show.svg";
import HideShowColor from "@/assets/images/hide_show_color.svg";
import HideShowWhite from "@/assets/images/hide_show_white.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  SET_TOGGLE_CARD,
  SET_TOGGLE_RANK,
  SET_TOGGLE_CORNER,
} from "@/lib/redux/reducers/actionTypes";


const HideShowButton = () => {
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const toggleReducer = useSelector((state) => state.toggleReducer);
  const [isVisible, setIsVisible] = useState(false);
  const [rankingChecked, setRankingChecked] = useState(toggleReducer.rank);
  const [cardChecked, setCardChecked] = useState(toggleReducer.card);
  const [cornerChecked, setCornerChecked] = useState(toggleReducer.corner);
  const [image, setImage] = useState(HideShow);
  const popoverRef = useRef(null);
  
  const togglePopover = () => {
    setIsVisible(!isVisible);
  };

  // const handleOptionClick = (option) => {
  //   setSelectedOption(option);
  //   setIsVisible(false);
  // };

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    setRankingChecked(toggleReducer.rank);
    setCardChecked(toggleReducer.card);
    setCornerChecked(toggleReducer.corner);
  }, [toggleReducer.rank, toggleReducer.card, toggleReducer.corner]);
  
  useEffect(() => {
    if (!rankingChecked || !cardChecked || !cornerChecked) {
        setImage(HideShowColor)
    } else {
        setImage(theme=='light' ? HideShow : HideShowWhite)
    }
  }, [rankingChecked, cardChecked, cornerChecked, theme])

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="hidden @md:flex relative items-center justify-center">
        <div
          onClick={togglePopover}
          className="flex items-center justify-center gap-1 hover:cursor-pointer"
        >
          <Image src={image} alt="Net88" width={20} height={14} />
          <div className={
              `text-xxs ${image === HideShow || image === HideShowWhite ? 'text-dark-gray dark:text-stroke-o3' : '!text-blue-match dark:text-blue-match'}`
            }>Ẩn / Hiện</div>

        </div>
        {isVisible && (
          <div
            className="absolute top-full w-[25rem] mt-1 z-40 bg-white rounded-lg shadow-lg"
            ref={popoverRef}
          >
            <div class="p-4 bg-white rounded-lg shadow-md">
              {/* <div>
                <h2 class="text-dark-gray text-xxs">Tỉ Lệ Kèo</h2>
                <div class="flex items-center space-x-3 mt-2">
                  <label class="inline-flex items-center">
                    <input
                      type="checkbox"
                      class="form-checkbox h-5 w-5 text-blue-match"
                      checked={hdcChecked}
                      onChange={() => {
                        setHdcChecked(!hdcChecked);
                        dispatch({
                          type: SET_TOGGLE_HDC,
                          payload: !hdcChecked,
                        });
                      }}
                    />
                    <span class="ml-2 text-blue-match font-bold">HDC</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input
                      type="checkbox"
                      class="form-checkbox h-5 w-5 text-blue-match"
                      checked={ouChecked}
                      onChange={() => {
                        setOuChecked(!ouChecked);
                        dispatch({
                          type: SET_TOGGLE_OU,
                          payload: !ouChecked,
                        });
                      }}
                    />
                    <span class="ml-2 text-blue-match font-bold">O/U</span>
                  </label>
                </div>
              </div>

              <hr class="my-4" /> */}

              <div>
                <h2 className={`text-dark-gray text-xxs`}>Thông Tin Thẻ</h2>
                <div className="flex flex-col space-y-2 mt-2">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-blue-match"
                      checked={toggleReducer.rank}
                      onChange={() => {
                        setRankingChecked(!rankingChecked);
                        dispatch({
                          type: SET_TOGGLE_RANK,
                          payload: !rankingChecked,
                        });
                      }}
                    />
                    <span className="ml-2 text-blue-match font-bold">
                      Xếp Hạng - Đội Bóng
                    </span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-blue-match"
                      checked={toggleReducer.card}
                      onChange={() => {
                        setCardChecked(!cardChecked);
                        dispatch({
                          type: SET_TOGGLE_CARD,
                          payload: !cardChecked,
                        });
                      }}
                    />
                    <span className="ml-2 text-blue-match font-bold">
                      Thẻ Vàng/Đỏ
                    </span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-blue-match"
                      checked={toggleReducer.corner}
                      onChange={() => {
                        setCornerChecked(!cornerChecked);
                        dispatch({
                          type: SET_TOGGLE_CORNER,
                          payload: !cornerChecked,
                        });
                      }}
                    />
                    <span className="ml-2 text-blue-match font-bold">Phạt Góc</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default React.memo(HideShowButton);